export const cleanName = name => name && name.toLowerCase().replace(/\s+/g, '');
export default (teamName, organizationName, game) => {
  if (cleanName(teamName) === cleanName(organizationName)) {
    return `${game && game.name ? `${game && game.name}` : `${teamName}`}`.trim();
  }
  return teamName;
};
